'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { FaFacebookF, FaInstagram, FaPinterestP } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { TfiYoutube } from 'react-icons/tfi';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { EXTERNAL_LINKS, ROUTER_LINKS, SOCIAL_MEDIA_LINKS } from '@/shared/constants/links-constants';
import styles from './footer.module.scss';
export default function Footer() {
  const $ = _c(85);
  const linksTranslations = useTranslations("global.links");
  const loggedUser = getUserBearerCookie();
  const legalTranslations = useTranslations("global.legal");
  const t0 = cx(styles.footer, loggedUser && styles.footer__isUserLogged);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <a className={styles.footerLink} href={SOCIAL_MEDIA_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="FacebookIcon"><FaFacebookF /></a>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <a className={styles.footerLink} href={SOCIAL_MEDIA_LINKS.twitter} target="_blank" rel="noopener noreferrer" aria-label="TwitterIcon"><FaXTwitter /></a>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <a className={styles.footerLink} href={SOCIAL_MEDIA_LINKS.youtube} target="_blank" rel="noopener noreferrer" aria-label="YoutubeIcon"><TfiYoutube /></a>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <a className={styles.footerLink} href={SOCIAL_MEDIA_LINKS.pinterest} target="_blank" rel="noopener noreferrer" aria-label="PinterestIcon"><FaPinterestP /></a>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.mediaLinks}>{t1}{t2}{t3}{t4}<a className={styles.footerLink} href={SOCIAL_MEDIA_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="InstagramIcon"><FaInstagram /></a></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== linksTranslations || $[6] !== loggedUser) {
    t6 = !loggedUser && <Link prefetch={false} className={styles.footerLink} href={ROUTER_LINKS.partner}>{linksTranslations("partner")}</Link>;
    $[5] = linksTranslations;
    $[6] = loggedUser;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ROUTER_LINKS.sitemap("rooms-for-rent");
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== linksTranslations) {
    t8 = linksTranslations("sitemap");
    $[9] = linksTranslations;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <Link className={styles.footerLink} href={t7}>{t8}</Link>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== linksTranslations) {
    t10 = linksTranslations("terms");
    $[13] = linksTranslations;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <Link className={styles.footerLink} href={ROUTER_LINKS.terms}>{t10}</Link>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== linksTranslations) {
    t12 = linksTranslations("faq");
    $[17] = linksTranslations;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = <a className={styles.footerLink} href={EXTERNAL_LINKS.faq} target="_blank" rel="noreferrer">{t12}</a>;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== linksTranslations) {
    t14 = linksTranslations("terms");
    $[21] = linksTranslations;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <Link className={styles.footerLink} href={ROUTER_LINKS.terms}>{t14}</Link>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== linksTranslations) {
    t16 = linksTranslations("privacy");
    $[25] = linksTranslations;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16) {
    t17 = <Link className={styles.footerLink} href={ROUTER_LINKS.privacy}>{t16}</Link>;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== linksTranslations) {
    t18 = linksTranslations("press");
    $[29] = linksTranslations;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18) {
    t19 = <Link className={styles.footerLink} href={ROUTER_LINKS.press}>{t18}</Link>;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== linksTranslations) {
    t20 = linksTranslations("affiliate-program");
    $[33] = linksTranslations;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t20) {
    t21 = <a className={styles.footerLink} href={EXTERNAL_LINKS.affiliateProgram} target="_blank" rel="noreferrer">{t20}</a>;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== linksTranslations) {
    t22 = linksTranslations("fair-housing");
    $[37] = linksTranslations;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t22) {
    t23 = <a className={styles.footerLink} href={EXTERNAL_LINKS.fairHousing} target="_blank" rel="noreferrer">{t22}</a>;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== linksTranslations) {
    t24 = linksTranslations("blog");
    $[41] = linksTranslations;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t24) {
    t25 = <Link className={styles.footerLink} prefetch={false} href={ROUTER_LINKS.blog} target="_blank">{t24}</Link>;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== linksTranslations) {
    t26 = linksTranslations("download-app");
    $[45] = linksTranslations;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t26) {
    t27 = <Link className={styles.footerLink} href={ROUTER_LINKS.downloadApp}>{t26}</Link>;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== linksTranslations) {
    t28 = linksTranslations("finding-a-room");
    $[49] = linksTranslations;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== t28) {
    t29 = <Link className={styles.footerLink} href={ROUTER_LINKS.findingRoom}>{t28}</Link>;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== linksTranslations) {
    t30 = linksTranslations("renting-out-a-room");
    $[53] = linksTranslations;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== t30) {
    t31 = <Link className={styles.footerLink} href={ROUTER_LINKS.rentingOutRoom}>{t30}</Link>;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== linksTranslations) {
    t32 = linksTranslations("roommate-finder");
    $[57] = linksTranslations;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t32) {
    t33 = <Link className={styles.footerLink} href={ROUTER_LINKS.roommateFinder}>{t32}</Link>;
    $[59] = t32;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] !== t11 || $[62] !== t13 || $[63] !== t15 || $[64] !== t17 || $[65] !== t19 || $[66] !== t21 || $[67] !== t23 || $[68] !== t25 || $[69] !== t27 || $[70] !== t29 || $[71] !== t31 || $[72] !== t33 || $[73] !== t6 || $[74] !== t9) {
    t34 = <div className={styles.links}>{t6}{t9}{t11}{t13}{t15}{t17}{t19}{t21}{t23}{t25}{t27}{t29}{t31}{t33}</div>;
    $[61] = t11;
    $[62] = t13;
    $[63] = t15;
    $[64] = t17;
    $[65] = t19;
    $[66] = t21;
    $[67] = t23;
    $[68] = t25;
    $[69] = t27;
    $[70] = t29;
    $[71] = t31;
    $[72] = t33;
    $[73] = t6;
    $[74] = t9;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== legalTranslations) {
    t35 = legalTranslations("do-not-share-personal-information");
    $[76] = legalTranslations;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] !== t35) {
    t36 = <div className={styles.links}><button className={styles.infoShare} onClick={_temp}>{t35}</button></div>;
    $[78] = t35;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className={styles.copyRight}>Roomster ©{" "}{new Date().getFullYear()}</div>;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== t0 || $[82] !== t34 || $[83] !== t36) {
    t38 = <div className={t0}>{t5}{t34}{t36}{t37}</div>;
    $[81] = t0;
    $[82] = t34;
    $[83] = t36;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  return t38;
}
function _temp(event) {
  event.preventDefault();
  if (globalThis.revisitCkyConsent) {
    globalThis.revisitCkyConsent();
  }
}